import cn from "classnames";
import { HeadingProps, HeadingTag } from "./types";
import styles from "./styles.module.scss";

export const Heading = ({
  level,
  children,
  id,
  className,
  dataTestId = "heading",
}: HeadingProps) => {
  const HeadingTag = `h${level}` as HeadingTag;

  return (
    <HeadingTag
      id={id}
      className={cn(styles.heading, styles[`level-${level}`], className)}
      data-test-id={dataTestId}
    >
      {children}
    </HeadingTag>
  );
};
